import React from 'react';
import Select from 'react-select';

const SelectInput = ({ options, value, onChange, placeholder, label, error, name, disabled = false }) => {
  return (
    <>
      <div className="relative w-full mt-5">
  <label
    htmlFor={name}
    className="absolute -top-2 left-3 bg-white px-1 text-xs font-medium text-primary-900"
  >
    {label}
  </label>

  <select
    id={name}
    name={name}
    disabled={disabled}
    value={value ?? ""}
    onChange={(e) =>
      onChange({
        target: {
          name,
          value: e.target.value,
        },
      })
    }
    className={`
      w-full
      h-11
      rounded-md
      border
      bg-white
      px-3
      pt-2
      text-sm
      outline-none
      transition
      ${
        error
          ? "border-red-400 focus:border-red-500 focus:ring-2 focus:ring-red-200"
          : "border-primary-400 focus:border-primary-500 focus:ring-2 focus:ring-primary-200"
      }
      ${disabled ? "bg-gray-100 cursor-not-allowed" : ""}
    `}
  >
    <option value="" disabled hidden>
      {placeholder}
    </option>

    {options?.map((option) => (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    ))}
  </select>

  {error && (
    <p className="mt-1 text-xs font-medium text-red-400">
      {error}
    </p>
  )}
</div>

    </>
  );
};

export default SelectInput;
